/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ContainerFindingsForHadolint extends models.ContainerFindings {
    constructor() {
        super();
        this.setDiscriminator("ContainerFindingsForHadolint");
    }

    getFixupPrototypeFunction() { return ContainerFindingsForHadolint.fixupPrototype; }

    static newInstance(model: Partial<ContainerFindingsForHadolint>): ContainerFindingsForHadolint {
        let obj = Object.assign(new ContainerFindingsForHadolint(), model);
        ContainerFindingsForHadolint.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ContainerFindingsForHadolint>): ContainerFindingsForHadolint {
        if (!model) return null;
        return ContainerFindingsForHadolint.newInstance(<ContainerFindingsForHadolint> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ContainerFindingsForHadolint) {
        if (!obj) return;

        models.ContainerFindingsForHadolint.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ContainerFindingsForHadolint): boolean {
        if (models.ContainerFindings.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ContainerFindingsForHadolint.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
